/** Display labels for the two application types. */
export const FORM_TYPE_LABEL = { rukn: 'Rukn', karkoon: 'Karkoon' }
